import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  MANAGE_SUBS_VALIDATE_SHIP_TO_UNDER_ANY_NATIONAL_ID_BEGIN,
  MANAGE_SUBS_VALIDATE_SHIP_TO_UNDER_ANY_NATIONAL_ID_SUCCESS,
  MANAGE_SUBS_VALIDATE_SHIP_TO_UNDER_ANY_NATIONAL_ID_FAILURE,
  MANAGE_SUBS_VALIDATE_SHIP_TO_UNDER_ANY_NATIONAL_ID_DISMISS_ERROR,
} from './constants';
import { API_REQUEST_URL } from '../../../common/apiConfig';

export function validateShipToUnderAnyNationalId(args = {}) {
  const { opcoId, customerId } = args;
  return (dispatch, getState) => {
    dispatch({ type: MANAGE_SUBS_VALIDATE_SHIP_TO_UNDER_ANY_NATIONAL_ID_BEGIN });
    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
        const doRequest = axios.post(
          `${API_REQUEST_URL}/validateShipToUnderAnyNationalID?opcoId=${opcoId}&customerId=${customerId}`,
          null,
          { headers: { Authorization: token } }
        );
      doRequest.then(
        res => {
          dispatch({
            type: MANAGE_SUBS_VALIDATE_SHIP_TO_UNDER_ANY_NATIONAL_ID_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        err => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: MANAGE_SUBS_VALIDATE_SHIP_TO_UNDER_ANY_NATIONAL_ID_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        }
      );
    });
    return promise;
  };
}

export function dismissValidateShipToUnderAnyNationalIdError() {
  return { type: MANAGE_SUBS_VALIDATE_SHIP_TO_UNDER_ANY_NATIONAL_ID_DISMISS_ERROR };
}

export function useValidateShipToUnderAnyNationalId() {
  const dispatch = useDispatch();
  const { validateShipToUnderAnyNationalIdPending, validateShipToUnderAnyNationalIdError, validateShipToUnderAnyNationalIdData } = useSelector(
    state => ({
      validateShipToUnderAnyNationalIdPending: state.manageSubs.validateShipToUnderAnyNationalIdPending,
      validateShipToUnderAnyNationalIdError: state.manageSubs.validateShipToUnderAnyNationalIdError,
      validateShipToUnderAnyNationalIdData: state.manageSubs.validateShipToUnderAnyNationalIdData,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => dispatch(validateShipToUnderAnyNationalId(...args)), [dispatch]);
  const boundDismissError = useCallback(() => dispatch(dismissValidateShipToUnderAnyNationalIdError()), [dispatch]);

  return {
    validateShipToUnderAnyNationalId: boundAction,
    validateShipToUnderAnyNationalIdPending,
    validateShipToUnderAnyNationalIdError,
    validateShipToUnderAnyNationalIdData,
    dismissValidateShipToUnderAnyNationalIdError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_SUBS_VALIDATE_SHIP_TO_UNDER_ANY_NATIONAL_ID_BEGIN:
      return {
        ...state,
        validateShipToUnderAnyNationalIdPending: true,
        validateShipToUnderAnyNationalIdError: null,
      };
    case MANAGE_SUBS_VALIDATE_SHIP_TO_UNDER_ANY_NATIONAL_ID_SUCCESS:
      return {
        ...state,
        validateShipToUnderAnyNationalIdPending: false,
        validateShipToUnderAnyNationalIdError: null,
        validateShipToUnderAnyNationalIdData: action.data,
      };
    case MANAGE_SUBS_VALIDATE_SHIP_TO_UNDER_ANY_NATIONAL_ID_FAILURE:
      return {
        ...state,
        validateShipToUnderAnyNationalIdPending: false,
        validateShipToUnderAnyNationalIdError: action.data.error,
      };
    case MANAGE_SUBS_VALIDATE_SHIP_TO_UNDER_ANY_NATIONAL_ID_DISMISS_ERROR:
      return {
        ...state,
        validateShipToUnderAnyNationalIdError: null,
      };
    default:
      return state;
  }
}
